export default __webpack_public_path__ + "static/media/person-1.fa983e5e.png";